import React from 'react'

const Pagination = ({
                        postsPerPage,
                        postsLength,
                        page,
                        changePage,
                    }) => {
    if (!postsLength) {
        return ''
    }
    
    const btnsQuantity = Math.ceil(postsLength / postsPerPage)
    let btnsArray = []
    
    const prevPage = () => page > 1 ? changePage(page - 1) : null
    const nextPage = () => page < btnsQuantity ? changePage(page + 1) : null
    const singleBtn = (num) => (
      <button
        key={num}
        className={`consultants__pagination__circles ${page === num ? 'passive' : 'active'}`}
        onClick={() => changePage(num)}>
          {num}
      </button>
    )
    
    const renderBtns = (currentNum) => {
        if (currentNum <= btnsQuantity) {
            btnsArray.push(singleBtn(currentNum))
            renderBtns(currentNum + 1)
        }
        return btnsArray
    }
    
    return (
      <div className="consultants__pagination">
          {renderBtns(1)}
      </div>
    )
}

export default Pagination;
